export default "__VITE_ASSET__BHdatgN4__"